// extracted by mini-css-extract-plugin
export var closed = "_7j-1";
export var resizer = "_7j-0";